import { parseSupplierQuantity } from '@utils/line-items/parseSupplierQuantity';

interface ResolveAdderOperandQuantityParams {
  extendedQuantity: number | string | null | undefined;
  supplierQuantity: number | string | null | undefined;
}

/**
 * Operand for a Quantity-of-Units dollar-rate adder. The supplier's own submitted quantity
 * (Smart Supplier Quantity) takes precedence when positive, else the buyer's extended_quantity
 * — both raw, with no items-per-unit division. Deliberately a separate function from
 * calculateLineItemPrice.ts's effectiveQuantity (same formula, different purpose: that one
 * still divides by items-per-unit for the line total) so a future change to one doesn't
 * silently drift the other.
 */
export const resolveAdderOperandQuantity = ({
  extendedQuantity,
  supplierQuantity,
}: ResolveAdderOperandQuantityParams): number => {
  const parsedSupplierQuantity = parseSupplierQuantity(supplierQuantity);
  if (parsedSupplierQuantity != null && parsedSupplierQuantity > 0) return parsedSupplierQuantity;

  return Number(extendedQuantity) || 0;
};
